module.exports = __webpack_public_path__ + "static/media/icon_faqs.56c9729a.svg";